import { useState } from 'react';
import { CalendarDays, Users, Briefcase, LayoutDashboard } from 'lucide-react';
import { clsx } from 'clsx';
import Agenda from '../../components/Agenda/Agenda';
import UsersList from '../../components/UsersList/UsersList';
import Revenue from '../../components/Revenue/Revenue';

const NAV_ITEMS = [
  { id: 'agenda', label: 'Agenda', icon: CalendarDays },
  { id: 'users', label: 'Usuários', icon: Users },
  { id: 'revenue', label: 'Meu Negócio', icon: Briefcase },
];

function NavItem({ item, active, onClick }) {
  const Icon = item.icon;
  return (
    <button
      onClick={() => onClick(item.id)}
      aria-current={active ? 'page' : undefined}
      className={clsx(
        'flex items-center gap-3 w-full px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-normal text-left',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus',
        active
          ? 'bg-primary-subtle text-primary'
          : 'text-text-secondary hover:text-text-primary hover:bg-surface-raised',
      )}
    >
      <Icon size={18} aria-hidden="true" />
      {item.label}
    </button>
  );
}

export default function Control() {
  const [section, setSection] = useState('agenda');

  const active = NAV_ITEMS.find((n) => n.id === section);

  return (
    <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col md:flex-row gap-6 min-h-[calc(100vh-4rem)]">

      {/* Sidebar desktop */}
      <aside className="hidden md:flex flex-col gap-1 w-52 shrink-0">
        <div className="flex items-center gap-2 px-3 py-2 mb-2">
          <LayoutDashboard size={16} className="text-text-muted" />
          <span className="text-xs font-semibold text-text-muted uppercase tracking-wider">Admin</span>
        </div>
        <nav aria-label="Navegação admin">
          {NAV_ITEMS.map((item) => (
            <NavItem key={item.id} item={item} active={section === item.id} onClick={setSection} />
          ))}
        </nav>
      </aside>

      {/* Tabs mobile */}
      <div className="md:hidden">
        <nav className="flex gap-1 bg-bg-secondary rounded-lg p-1" aria-label="Navegação admin mobile">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => setSection(item.id)}
                aria-current={section === item.id ? 'page' : undefined}
                className={clsx(
                  'flex-1 flex flex-col items-center gap-1 py-2 rounded-md text-xs font-medium transition-colors duration-normal',
                  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus',
                  section === item.id
                    ? 'bg-surface text-primary shadow-sm'
                    : 'text-text-muted hover:text-text-primary',
                )}
              >
                <Icon size={16} aria-hidden="true" />
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Conteúdo */}
      <main className="flex-1 min-w-0">
        <h1 className="text-2xl font-bold text-text-primary mb-6">{active?.label}</h1>
        {section === 'agenda' && <Agenda />}
        {section === 'users' && <UsersList />}
        {section === 'revenue' && <Revenue />}
      </main>

    </div>
  );
}
